import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import shortfetch from "../../components/data/fetch";
import SimpleModal from "../../components/data/image_modal";
import Plattegrond from "../../components/plattegrond/plattegrond";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_array: {},
      isLoading: true,
    };
  }
  async fetch_data() {
    let post_json = {
      type: "random_model_data",
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    console.log("fetched_data", data.data_array);

    this.setState({
      data_array: data.data_array,
    });
  }

  componentDidMount() {
    if (!this.props.notVerified) {
      this.fetch_data();
    }
  }

  // deze funtie weghalen als het hebben van de voortgang niet meer nodig is.
  aantal = 0;
  totaal = 0;
  total_spend = 0;
  async tijdelijkefunctie() {
    let data = await shortfetch({
      type: "data_statiscial_overview",
      auth: localStorage.getItem("auth"),
    });
    console.log(data);
    this.total_spend = data.total_spend;

    this.aantal = 0;
    this.totaal = 0;

    data.data_array.forEach((model) => {
      this.totaal += 1;

      const Nieuwwaarde = Math.round(
        parseFloat(model.Nieuwwaarde.replace(",", ".")),
        2
      );
      const InkoopModel = Math.round(
        parseFloat(model.InkoopModel.replace(",", ".")),
        2
      );
      if (
        (Nieuwwaarde != 0 && InkoopModel == 0) ||
        (Nieuwwaarde == 0 && InkoopModel != 0)
      ) {
        this.aantal += 1;
      }
    });
    this.setState({ isLoading: false });
  }

  render() {
    if (this.state.isLoading) {
      this.tijdelijkefunctie();
      return <div></div>;
    }

    if (this.props.notVerified) {
      return (
        <React.Fragment>
          <Grid
            container
            style={{ width: "100%" }}
            justify="center"
            alignItems="center"
          >
            <Grid item xs={9} container justify="center" alignItems="center">
              <h1 style={{ textAlign: "center" }}>
                Om gebruik te maken van het unimog gedeelte van de website, moet
                je eerst zijn ingelogd.
              </h1>
            </Grid>
          </Grid>
        </React.Fragment>
      );
    }

    console.log(process.env.API_URL);

    const { ModelID } = this.state.data_array;
    return (
      <React.Fragment>
        <Grid container style={{ width: "100%" }} justify="center">
          <Grid item xs={11} container justify="flex-start" spacing={4}>
            <Grid item xs={6} container>
              <Grid item xs={12}>
                <h2>Welkom unimog vriend</h2>
                <p>
                  Deze website is bedoeld voor mijn vader. De website is gebouwd
                  op een SQL database waarin alle data over de modellen is
                  opgenomen. Gebruik de zoekbalk om naar specifieke modellen te
                  zoeken.
                </p>
              </Grid>
              {/* <Grid item xs={12}>
                <h1>
                  {/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                  )
                    ? "mobile"
                    : "COMPUTER"}
                </h1>
              </Grid> */}
              <Grid item xs={12}>
                {/* <h1>
                  Totaal uitgegeven aan modellen: {"€"}
                  {Number(this.total_spend).toLocaleString()}
                  {""}
                  {",-"}
                </h1> */}
              </Grid>
              <Grid item xs={12}>
                <h3>To do:</h3>
                <ul>
                  <li>Scanner voor dubbele modellen toevoegen</li>
                  <ul>
                    <li>Moet scannen op frabikantsnummer</li>
                  </ul>
                  <li>Filter aanpassen/toevoegen</li>
                  <ul>
                    <li>Kleur</li>
                    <li>Type</li>
                    <li>Verhouding</li>
                    <li>Toepassing</li>
                    <li>Materialen</li>
                  </ul>
                  <li>Totaal overzicht toevoegen</li>
                  <ul>
                    <li>Grafiek prijs per merk</li>
                    <li>Tabel met statestieken totaal</li>
                  </ul>
                  <li>Pins toevoegen</li>
                  <ul>
                    <li>Invulscherm</li>
                    <li>Data overzicht</li>
                  </ul>
                  <li>Video's toevoegen</li>
                  <ul>
                    <li>Invulescherm</li>
                    <li>Data overzicht</li>
                    <li>Video speler</li>
                  </ul>
                  <li>
                    Mogelijk maken dat foto's kunnen worden toegevoegd bij de
                    modellen invulscherm
                  </li>
                </ul>
              </Grid>
              {/* <Plattegrond /> */}
            </Grid>
            <Grid item xs={6}>
              <h2>Model Highlight</h2>
              <Grid container>
                <Grid item xs={12}>
                  <h3>
                    {this.state.data_array.naam +
                      " " +
                      this.state.data_array.ModelID}
                  </h3>
                  <h4>{this.state.data_array.FabrikantOmschrijving}</h4>
                </Grid>
                <Grid item xs={12}>
                  {" "}
                  <SimpleModal
                    src={`/media/Model_images/Model-${ModelID}/${ModelID}-Algemeen.jpg`}
                    src_min={`/media/Model_images/Model-${ModelID}/${ModelID}-Algemeen_min.jpg`}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default Home;
